import React from 'react'
import { CSSProperties } from 'react'

import styled, { css } from 'styled-components'
import { colors } from '../shared-constants/colors'
import { fontSize, fontsWeight } from '../shared-constants/fonts'

export interface ICText {
  [x: string]: any
  locale?: string
  fontWeight?: string
  fontSize?: string
  style?: CSSProperties
  tag?: string
  onClick?: () => void
  color?: string
  className?: string
}

export const CText: React.FC<ICText> = (props) => {
  return (
    <>
      {props.tag === 'a' ? (
        <A {...props} onClick={props.onClick} locale={props.locale}>
          {props.children}
        </A>
      ) : props.tag === 'span' ? (
        <Span
          {...props}
          fontSize={props.fontSize}
          fontWeight={props.fontWeight}
          locale={props.locale}
        >
          {props.children}
        </Span>
      ) : (
        <P
          {...props}
          fontSize={props.fontSize}
          fontWeight={props.fontWeight}
          locale={props.locale}
        >
          {props.children}
        </P>
      )}
    </>
  )
}
const GlobalStyle = css<any>`
  font-weight: ${(props) =>
    props.fontWeight === fontsWeight.BOLD
      ? fontsWeight.BOLD
      : fontsWeight.LIGHT};
  font-size: ${(props) => (props.fontSize ? props.fontSize : fontSize.SMALL)};
  color: ${(props) => (props.color ? props.color : colors.text1)};
`

const P = styled.p<any>`
  ${GlobalStyle}
`
const A = styled.a<any>`
  ${GlobalStyle}
`

const Span = styled.span<any>`
  ${GlobalStyle}
`
